import request from '@/router/axios'

const base = '/api/produce/stock-take'

/** 月度合规报告（yyyy-MM） */
export const getComplianceReport = (yearMonth) =>
  request({
    url: `${base}/compliance-report`,
    method: 'get',
    params: { yearMonth }
  })

/** 有盘点数据的月份列表 yyyy-MM，降序 */
export const getComplianceMonths = () =>
  request({
    url: `${base}/compliance-report/months`,
    method: 'get'
  })
